var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',[_c('v-tab',{attrs:{"to":"/user/artworks/published","exact":""}},[_vm._v("Published")]),_c('v-tab',{attrs:{"to":"/user/artworks/custom","exact":""}},[_vm._v("Custom")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }